(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('DaySchemeTime', ['HelperService', DaySchemeTimeFactoryFn]);

    function DaySchemeTimeFactoryFn(HelperService) {

        var DaySchemeTime = function () {

            // default
            this.id = 0;
            this.deleted = false;
            this.fK_AgendaLabel = null;
            this.fK_DayScheme = null;
            this.time = null;
            this.readonly = false; // default extra day 
            this.agendaLabelDto = null;

            // view variable
            this.hour = -1;
            this.minute = -1;
            // time
            this.vmTime = null;
            // id
            this.vmId = Math.random();
            // selected ?
            this.vmSelected = false;
            // only for show (template) -> no saving -> just for showing
            this.vmOnlyShow = false;


            // backend save preparation
            function prepareForSave(dayschemeId, dayScheme) {
                var self = this;

                // Always set id to null -> because every time it should be inserted !
                // existing ones will be deleted -> clearer in backend...
                self.id = 0;

                self.fK_DayScheme = dayschemeId;
                self.fK_AgendaLabel = self.agendaLabelDto ? self.agendaLabelDto.id : null;
                // time
                var time = new Date(dayScheme.date);
                time.setHours(self.hour);
                time.setMinutes(self.minute);
                time.setSeconds(0);
                time.setMilliseconds(0);
                self.time = HelperService.backendDate(time);

                delete self.vmSelected;
                // delete self.vmTime;
                delete self.minute;
                delete self.hour;
                // delete self.agendaLabelDto;
                delete self.timestamp;
                delete self.caption;
                delete self.captionIntern;
                delete self.captionWebsite;
                delete self.holidayCaption;
                delete self.vmOnlyShow;

            }

            this.prepareForSave = prepareForSave;



        };

        // extend item
        DaySchemeTime.prototype.extend = function (time) {
            var self = this;
            angular.extend(self, time);
            // default it is now selected by label
            this.vmSelected = true;
            // init
            timing(self);
        };

        // init object
        DaySchemeTime.prototype.init = function (hour, minute) {
            var self = this;
            self.hour = hour;
            self.minute = minute;
            timing(self);
        };

        // copy object
        DaySchemeTime.prototype.copy = function (time) {
            var self = this;
            angular.extend(self, time);
            self.vmId = Math.random();
        };

        // prepare timing
        function timing(self) {
            // time
            self.vmTime = (self.hour < 10 ? '0'.concat(self.hour) : self.hour) + ':' + (self.minute < 10 ? '0'.concat(self.minute) : self.minute);
        }


        return DaySchemeTime;


    }
})();